import { createContext, useEffect, useRef, useState } from "react";
import { NonZeroBalanceLedger, NonZeroBalanceLedgersData } from "./types";
import { MRT_TableInstance } from "material-react-table";
import { processLedgerData } from "./processLedgerData";
import { searchEarnestDepositLedgers, searchNonZeroLedgerBalances } from "../dashboard/utils/nonZeroLedgerBalancesUtils";

// ----------------------------------------------------------------------

const NonZeroBalanceLedgersContext = createContext<NonZeroBalanceLedgersData>({} as NonZeroBalanceLedgersData);

type ReportSource = "nonZeroBalances" | "deposits";

function NonZeroBalanceLedgersContextProvider({
  children,
  reportSource = "nonZeroBalances"
}: {
  children: JSX.Element;
  reportSource?: ReportSource;
}) {
  const [loading, setLoading] = useState(true);
  const [nonZeroBalanceLedgers, setNonZeroBalanceLedgers] = useState<NonZeroBalanceLedger[]>([]);
  const [assignedToMe, setAssignedToMe] = useState<boolean>(true);

  const tableRef = useRef<MRT_TableInstance<NonZeroBalanceLedger> | null>(null);
  const fetchNonZeroBalanceLedgers = async (useLoader: boolean = true) => {
    if (useLoader) {
      setLoading(true);
    }

    const data =
      reportSource === "deposits" ? await searchEarnestDepositLedgers() : await searchNonZeroLedgerBalances();
    const ledgers = processLedgerData(data);
    setNonZeroBalanceLedgers(ledgers);
    if (useLoader) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNonZeroBalanceLedgers(true);
  }, [reportSource]);

  return (
    <NonZeroBalanceLedgersContext.Provider
      value={{
        loading,
        nonZeroBalanceLedgers,
        setNonZeroBalanceLedgers,
        assignedToMe,
        setAssignedToMe,
        fetchNonZeroBalanceLedgers,
        tableRef
      }}
    >
      {children}
    </NonZeroBalanceLedgersContext.Provider>
  );
}

export { NonZeroBalanceLedgersContextProvider, NonZeroBalanceLedgersContext };
